import { render, staticRenderFns } from "./AdminViaje.vue?vue&type=template&id=ab8668d2&scoped=true"
import script from "./AdminViaje.vue?vue&type=script&lang=js"
export * from "./AdminViaje.vue?vue&type=script&lang=js"
import style0 from "./AdminViaje.vue?vue&type=style&index=0&id=ab8668d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab8668d2",
  null
  
)

export default component.exports